import React, { Component } from 'react'
import { BreadCumb, DataTables, NavBar, TimeOut } from '../../components';
import { DISPATCH_ID } from '../../libs/utils/Const';
import { connect } from 'react-redux';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';
let apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "Serie", value: true },//0
    { title: "Estatus", value: true },//1
    { title: "Num.Doc", value: true },//2

    { title: "Cliente", value: true },//3
    { title: "Nombre", value: true },//4
    { title: "Fecha Cont.", value: true },//5

    { title: "Comentarios", value: true },//6
    { title: "Total", value: true },//7
    { title: "Fecha Vencimiento", value: true },//8
]

class PendingTimbraDocsView extends Component {
    constructor(props) {
        super(props)
        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            headers: headersDataTable,
            data: [],
        }
    }

    SearchPendingTimbraDocs = async (params) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        if (params.docType && params.docType === '--') {
            showAlert({ type: 'info', timeOut: 5000, message: "No has seleccionado un tipo de documento para buscar" });
            return
        }

        enableSpinner(true);
        const responseApi = await apiClient.getPendingTimbraDocs(params);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', timeOut: 5000, message: responseApi?.message ?? 'Error' });
            return
        } else if (responseApi.data && Array.isArray(responseApi.data) && responseApi.data.length === 0) {
            showAlert({ type: 'info', timeOut: 5000, message: "No hay información con esos parámetros de búsqueda" });
        }

        let filteredDocsBySeries = [];
        let newArraySeries = [];

        const dataSerie = {
            docType: params.docType,
            docSubType: "--"
        };

        enableSpinner(true);
        const seriesResponse = await apiClient.getSeries(dataSerie);
        enableSpinner(false);

        const returnedProp = await returnProperty(params.docType);
        const ValidateSeries = user[returnedProp] ? user[returnedProp] : "";

        if (!user || ValidateSeries === "") {
            showAlert({ type: 'warning', timeOut: 5000, message: "Ocurrió un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador" });
            this.setState({
                data: [],
            });
            return;
        }

        const seriesUsers = ValidateSeries.split("|");


        for (let index = 0; index < seriesUsers.length; index++) {
            const serieUser = seriesUsers[index];
            for (let index = 0; index < seriesResponse.data.length; index++) {
                const serieResponse = seriesResponse.data[index];
                if (Number(serieResponse.Series) === Number(serieUser) && Number(serieResponse.ObjectCode) === Number(params.docType) && serieResponse.DocSubType === '--') {
                    newArraySeries.push(serieResponse);
                }
            }
        }

        if (newArraySeries.length === 0) {
            showAlert({ type: 'warning', timeOut: 5000, message: "El usuario no tiene serie permitida de escritura y lectura" });
            return;
        }

        for (let index = 0; index < responseApi.data.length; index++) {
            const document = responseApi.data[index];
            for (let index = 0; index < newArraySeries.length; index++) {
                const serie = newArraySeries[index];
                if (Number(document.SeriesCode) === Number(serie.Series)) {
                    filteredDocsBySeries.push(document);
                }
            }
        }

        await this.setState({
            data: filteredDocsBySeries ?? []
        })
    }

    render() {
        const { headers, data, _user } = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <BreadCumb subitem1={'DOCUMENTOS PENDIENTES POR TIMBRAR'} url1={'#'} />
                <TimeOut />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <span id="linkOrdProv" className="text-muted">
                            DOCUMENTOS PENDIENTES POR TIMBRAR
                        </span>
                    </h2>
                    <DataTables
                        headers={headers}
                        view={"pendingTimbraDoc"}
                        data={data}
                        search={this.SearchPendingTimbraDocs}
                        handleRemarks={() => { }}
                        handleStatusAuthorization={() => { }}
                    />
                </div>
            </div>
        );
    }
}

const returnProperty = (TypeDoc) => {
    let returnedProp = '';
    switch (Number(TypeDoc)) {
        case 13:
            returnedProp = 'U_FMB_ValidateSeriesOINV';
            break;
        case 14:
            returnedProp = 'U_FMB_ValidateSeriesORIN';
            break;
        case 24:
            returnedProp = 'U_FMB_ValidateSeriesORCT';
            break;
        case 203:
            returnedProp = 'U_FMB_ValidateSeriesODPI';
            break;
        default:
            returnedProp = '';
            break;
    }
    return returnedProp;
}


const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
}

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PendingTimbraDocsView);